// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-heading {
  color: var(--primary-color);
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  margin-bottom: 14px;
}

.form {
  display: flex;
  flex-direction: column;
}
.form .login-form-field {
  width: 100%;
  margin-bottom: 16px;
}
.form .element-title {
  color: var(--dark-grey-font);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 7px;
}
.form .checkbox-row {
  margin: 3px 0 18px 0;
}
.form .terms-row {
  margin: 3px 0 16px 0;
}
.form .terms-row .terms-and-condition {
  cursor: pointer;
  color: var(--link-color);
  font-weight: 600;
}
.form .error-msg {
  display: block;
  font-size: 11px;
  margin-top: 4px;
  margin-bottom: 10px;
}
.form button {
  width: 100%;
  border-radius: 10px !important;
  margin-top: 8px;
}

.spinner {
  width: 12px;
  height: 12px;
  border: 2px solid var(--spinner-border-color);
  border-top-color: var(--spinner-border-top-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.field {
  border: none;
  padding: 0;
  margin: 0 0 16px 0;
}
.field legend {
  display: block;
  padding: 0;
  width: 100%;
  float: none;
}

.dropzone {
  border: 1px solid var(--grey-border);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 110px;
  gap: 5px;
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
}
.dropzone.is-dragover {
  border-color: var(--primary-color);
  background-color: color-mix(in srgb, var(--primary-color) 6%, transparent);
}
.dropzone__input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.dropzone__icon {
  width: 36px;
  height: 36px;
  border: 1px solid var(--grey-border);
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.dropzone__icon img {
  width: 18px;
}
.dropzone__label {
  pointer-events: none;
}
.dropzone__text {
  color: var(--secondary-grey-color);
  font-size: 13px;
}
.dropzone__text strong {
  font-size: 13px;
  color: var(--link-color);
  font-weight: 600;
}
.dropzone .hint {
  margin: 0;
  color: var(--secondary-grey-color);
  font-weight: 400;
  font-size: 11px;
  pointer-events: none;
}

.uploaded-document-container {
  border: 1px solid var(--grey-border);
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.uploaded-document-container .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 40px;
  flex-shrink: 0;
  color: var(--secondary-grey-color);
  border: 1px solid var(--grey-border);
  border-radius: 8px;
}
.uploaded-document-container .logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.uploaded-document-container .logo mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.uploaded-document-container .details {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}
.uploaded-document-container .details__name {
  color: var(--dark-grey-font);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.uploaded-document-container .details__size {
  color: var(--secondary-grey-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.uploaded-document-container .delete-document {
  flex-shrink: 0;
  cursor: pointer;
}

.terms-and-condition {
  cursor: pointer;
  color: var(--link-color);
  font-weight: 600;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

@media (max-width: 767px) {
  .page-heading {
    font-size: 20px;
    line-height: 26px;
  }
  .form .login-form-field {
    margin-bottom: 10px;
  }
  .form .element-title {
    font-size: 13px;
    margin-bottom: 6px;
  }
}
@media (max-width: 479px) {
  .page-heading {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .form .login-form-field {
    margin-bottom: 12px;
  }
  .form .element-title {
    font-size: 12.5px;
    line-height: 18px;
    margin-bottom: 6px;
  }
  .form .terms-row ::ng-deep .mat-mdc-checkbox label,
  .form .checkbox-row ::ng-deep .mat-mdc-checkbox label {
    font-size: 13px;
  }
  .form button {
    border-radius: 8px !important;
  }
  .dropzone {
    height: 96px;
  }
  .dropzone__icon {
    width: 32px;
    height: 32px;
  }
  .uploaded-document-container {
    padding: 8px 10px;
    gap: 8px;
  }
  .uploaded-document-container .logo {
    width: 36px;
    height: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/company-details/company-details.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;AADD;AAGC;EACC,WAAA;EACA,mBAAA;AADF;AAIC;EACC,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAFF;AAKC;EACC,oBAAA;AAHF;AAMC;EACC,oBAAA;AAJF;AAME;EACC,eAAA;EACA,wBAAA;EACA,gBAAA;AAJH;AAQC;EACC,cAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AANF;AASC;EACC,WAAA;EACA,8BAAA;EACA,eAAA;AAPF;;AAWA;EACC,WAAA;EACA,YAAA;EACA,6CAAA;EACA,iDAAA;EACA,kBAAA;EACA,oCAAA;AARD;;AAWA;EACC;IACC,yBAAA;EARA;AACF;AAaA;EACC,YAAA;EACA,UAAA;EACA,kBAAA;AAXD;AAaC;EACC,cAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AAXF;;AAeA;EACC,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,uFAAA;AAZD;AAcC;EACC,kCAAA;EACA,0EAAA;AAZF;AAeC;EACC,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAbF;AAgBC;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAdF;AAgBE;EACC,WAAA;AAdH;AAkBC;EACC,oBAAA;AAhBF;AAmBC;EACC,kCAAA;EACA,eAAA;AAjBF;AAmBE;EACC,eAAA;EACA,wBAAA;EACA,gBAAA;AAjBH;AAqBC;EACC,SAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAnBF;;AAuBA;EACC,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AApBD;AAsBC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EACA,oCAAA;EACA,kBAAA;AApBF;AAsBE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AApBH;AAuBE;EACC,eAAA;EACA,WAAA;EACA,YAAA;AArBH;AAyBC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAvBF;AAyBE;EACC,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvBH;AA0BE;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAxBH;AA4BC;EACC,cAAA;EACA,eAAA;AA1BF;;AA8BA;EACC,eAAA;EACA,wBAAA;EACA,gBAAA;AA3BD;;AA8BA;;EAEC,wBAAA;EACA,SAAA;AA3BD;;AA8BA;EACC,0BAAA;AA3BD;;AC3DQ;ED2FP;IACC,eAAA;IACA,iBAAA;EA5BA;EAgCA;IACC,mBAAA;EA9BD;EAiCA;IACC,eAAA;IACA,kBAAA;EA/BD;AACF;ACzEQ;ED8GP;IACC,eAAA;IACA,iBAAA;IACA,mBAAA;EAlCA;EAsCA;IACC,mBAAA;EApCD;EAuCA;IACC,iBAAA;IACA,iBAAA;IACA,kBAAA;EArCD;EA0CC;;IACC,eAAA;EAvCF;EA2CA;IACC,6BAAA;EAzCD;EA6CD;IACC,YAAA;EA3CA;EA6CA;IACC,WAAA;IACA,YAAA;EA3CD;EA+CD;IACC,iBAAA;IACA,QAAA;EA7CA;EA+CA;IACC,WAAA;IACA,YAAA;EA7CD;AACF","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.page-heading {\n\tcolor: var(--primary-color);\n\tfont-weight: 700;\n\tfont-size: 22px;\n\tline-height: 28px;\n\tmargin-bottom: 14px;\n}\n\n.form {\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t.login-form-field {\n\t\twidth: 100%;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t.element-title {\n\t\tcolor: var(--dark-grey-font);\n\t\tfont-weight: 500;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tmargin-bottom: 7px;\n\t}\n\n\t.checkbox-row {\n\t\tmargin: 3px 0 18px 0;\n\t}\n\n\t.terms-row {\n\t\tmargin: 3px 0 16px 0;\n\n\t\t.terms-and-condition {\n\t\t\tcursor: pointer;\n\t\t\tcolor: var(--link-color);\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.error-msg {\n\t\tdisplay: block;\n\t\tfont-size: 11px;\n\t\tmargin-top: 4px;\n\t\tmargin-bottom: 10px;\n\t}\n\n\tbutton {\n\t\twidth: 100%;\n\t\tborder-radius: 10px !important;\n\t\tmargin-top: 8px;\n\t}\n}\n\n.spinner {\n\twidth: 12px;\n\theight: 12px;\n\tborder: 2px solid var(--spinner-border-color);\n\tborder-top-color: var(--spinner-border-top-color);\n\tborder-radius: 50%;\n\tanimation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n// Upload fields (fieldset per document), ported from customer-website's\n// dropzone + uploaded-document-container design so both apps' upload UIs match.\n.field {\n\tborder: none;\n\tpadding: 0;\n\tmargin: 0 0 16px 0;\n\n\tlegend {\n\t\tdisplay: block;\n\t\tpadding: 0;\n\t\twidth: 100%;\n\t\tfloat: none;\n\t}\n}\n\n.dropzone {\n\tborder: 1px solid var(--grey-border);\n\tborder-radius: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 110px;\n\tgap: 5px;\n\tcursor: pointer;\n\tposition: relative;\n\ttransition: box-shadow .15s ease, border-color .15s ease, background-color .15s ease;\n\n\t&.is-dragover {\n\t\tborder-color: var(--primary-color);\n\t\tbackground-color: color-mix(in srgb, var(--primary-color) 6%, transparent);\n\t}\n\n\t&__input {\n\t\tposition: absolute;\n\t\tinset: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\topacity: 0;\n\t\tcursor: pointer;\n\t}\n\n\t&__icon {\n\t\twidth: 36px;\n\t\theight: 36px;\n\t\tborder: 1px solid var(--grey-border);\n\t\tborder-radius: 8px;\n\t\tbox-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpointer-events: none;\n\n\t\timg {\n\t\t\twidth: 18px;\n\t\t}\n\t}\n\n\t&__label {\n\t\tpointer-events: none;\n\t}\n\n\t&__text {\n\t\tcolor: var(--secondary-grey-color);\n\t\tfont-size: 13px;\n\n\t\tstrong {\n\t\t\tfont-size: 13px;\n\t\t\tcolor: var(--link-color);\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.hint {\n\t\tmargin: 0;\n\t\tcolor: var(--secondary-grey-color);\n\t\tfont-weight: 400;\n\t\tfont-size: 11px;\n\t\tpointer-events: none;\n\t}\n}\n\n.uploaded-document-container {\n\tborder: 1px solid var(--grey-border);\n\tborder-radius: 12px;\n\tpadding: 10px 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\n\t.logo {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 44px;\n\t\theight: 40px;\n\t\tflex-shrink: 0;\n\t\tcolor: var(--secondary-grey-color);\n\t\tborder: 1px solid var(--grey-border);\n\t\tborder-radius: 8px;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: contain;\n\t\t}\n\n\t\tmat-icon {\n\t\t\tfont-size: 22px;\n\t\t\twidth: 22px;\n\t\t\theight: 22px;\n\t\t}\n\t}\n\n\t.details {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tmin-width: 0;\n\n\t\t&__name {\n\t\t\tcolor: var(--dark-grey-font);\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 20px;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t}\n\n\t\t&__size {\n\t\t\tcolor: var(--secondary-grey-color);\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 18px;\n\t\t}\n\t}\n\n\t.delete-document {\n\t\tflex-shrink: 0;\n\t\tcursor: pointer;\n\t}\n}\n\n.terms-and-condition {\n\tcursor: pointer;\n\tcolor: var(--link-color);\n\tfont-weight: 600;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0;\n}\n\ninput[type=number] {\n\t-moz-appearance: textfield;\n}\n\n// ---------- Tablet (below md) ----------\n@include respond-below(md) {\n\t.page-heading {\n\t\tfont-size: 20px;\n\t\tline-height: 26px;\n\t}\n\n\t.form {\n\t\t.login-form-field {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\n\t\t.element-title {\n\t\t\tfont-size: 13px;\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\t}\n}\n\n// ---------- Mobile (below xs) ----------\n@include respond-below(xs) {\n\t.page-heading {\n\t\tfont-size: 18px;\n\t\tline-height: 24px;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.form {\n\t\t.login-form-field {\n\t\t\tmargin-bottom: 12px;\n\t\t}\n\n\t\t.element-title {\n\t\t\tfont-size: 12.5px;\n\t\t\tline-height: 18px;\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\n\t\t.terms-row,\n\t\t.checkbox-row {\n\t\t\t::ng-deep .mat-mdc-checkbox label {\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\t\t}\n\n\t\tbutton {\n\t\t\tborder-radius: 8px !important;\n\t\t}\n\t}\n\n\t.dropzone {\n\t\theight: 96px;\n\n\t\t&__icon {\n\t\t\twidth: 32px;\n\t\t\theight: 32px;\n\t\t}\n\t}\n\n\t.uploaded-document-container {\n\t\tpadding: 8px 10px;\n\t\tgap: 8px;\n\n\t\t.logo {\n\t\t\twidth: 36px;\n\t\t\theight: 32px;\n\t\t}\n\t}\n}\n","// custom fons facemizxin\n\n@mixin font-face($font-family, $url) {\n    @font-face {\n        font-family: '#{$font-family}';\n        src: url('#{$url}.eot');\n        src: url('#{$url}.eot?#iefix') format('embedded-opentype'),\n        url('#{$url}.woff') format('woff'),\n        url('#{$url}.ttf') format('truetype'),\n        url('#{$url}.svg') format('svg');\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n\n\n//custom font resposnive muin\n$font-base-min: 14px;\n$font-base-max: 6;\n$breakmin: 320px;\n$breakmax: 768px;\n$customSize: 5px;\n\n@mixin font-responsive($fmin, $fdiff, $breakmin, $breakdiff) {\n    font-size: calc(#{$fmin} + #{$fdiff} * ((100vw - #{$breakmin}) / #{$breakdiff}));\n\n    @media(max-width: $breakmin) {\n        font-size: $fmin;\n    }\n\n    @media(min-width: round($breakmin + $breakmax)) {\n        font-size: round($fmin + $fdiff);\n    }\n\n    @media(max-width: $breakmax) {\n        // font-size: round($fmin + 3px);\n        font-size: calc(#{$fmin} + #{$customSize});\n    }\n}\n\n\n// custom font source mmixins\n\n@mixin font($colour: false, $weight: false, $lh: false, $spacing: false) {\n\n    // @if $size { font-size: $size; }\n    @if $colour {\n        color: $colour;\n    }\n\n    @if $weight {\n        font-weight: $weight;\n    }\n\n    @if $lh {\n        line-height: $lh;\n    }\n\n    @if $spacing {\n        letter-spacing: $spacing;\n    }\n}\n\n\n// custom input placeholder mixins\n\n@mixin input-placeholder {\n    &.placeholder {\n        @content;\n    }\n\n    &:-moz-placeholder {\n        @content;\n    }\n\n    &::-moz-placeholder {\n        @content;\n    }\n\n    &:-ms-input-placeholder {\n        @content;\n    }\n\n    &::-webkit-input-placeholder {\n        @content;\n    }\n}\n\n\n// A map of breakpoints.\n$breakpoints: (\n    xs: 480px,\n    sm: 576px,\n    md: 768px,\n    lg: 992px,\n    xl: 1200px,\n    xxl: 1600px,\n    ipadSize: 768px,\n    ipadmin:481px,\n    ipadmax:1024px,\n    ipadlandscape:1320px,\n\n);\n\n// Respond above.\n@mixin respond-above($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (min-width: $breakpoint-value) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n\n@mixin respond-below($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (max-width: ($breakpoint-value - 1)) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n@mixin respond-between($lower, $upper) {\n\n    // If both the lower and upper breakpoints exist in the map.\n    @if map-has-key($breakpoints, $lower) and map-has-key($breakpoints, $upper) {\n\n        // Get the lower and upper breakpoints.\n        $lower-breakpoint: map-get($breakpoints, $lower);\n        $upper-breakpoint: map-get($breakpoints, $upper);\n\n        // Write the media query.\n        @media (min-width: $lower-breakpoint) and (max-width: ($upper-breakpoint - 1)) {\n            @content;\n        }\n\n        // If one or both of the breakpoints don't exist.\n    }\n\n    @else {\n\n        // If lower breakpoint is invalid.\n        @if (map-has-key($breakpoints, $lower)==false) {\n\n            // Log a warning.\n            @warn 'Your lower breakpoint was invalid: #{$lower}.';\n        }\n\n        // If upper breakpoint is invalid.\n        @if (map-has-key($breakpoints, $upper)==false) {\n\n            // Log a warning.\n            @warn 'Your upper breakpoint was invalid: #{$upper}.';\n        }\n    }\n}\n\n\n// @media only screen and (device-width: 768px) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\n//     /* For landscape layouts only */\n// }\n\n/// vernodr prefixes\n\n@mixin css3-prefix($prop, $value) {\n    -webkit-#{$prop}: #{$value};\n    -moz-#{$prop}: #{$value};\n    -ms-#{$prop}: #{$value};\n    -o-#{$prop}: #{$value};\n    #{$prop}: #{$value};\n}\n\n\n//  vertical cneter\n@mixin vertical-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n//keyframe miins\n\n@mixin keyframes($name) {\n    @-webkit-keyframes #{$name} {\n        @content;\n    }\n\n    @-moz-keyframes #{$name} {\n        @content;\n    }\n\n    @keyframes #{$name} {\n        @content;\n    }\n}\n\n//absolute positoning\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n\n//arrow minis\n@mixin arrow($direction: down, $size: 5px, $color: #555) {\n    width: 0;\n    height: 0;\n\n    @if ($direction ==left) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-right: $size solid $color;\n    }\n\n    @else if ($direction ==right) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-left: $size solid $color;\n    }\n\n    @else if ($direction ==down) {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-top: $size solid $color;\n    }\n\n    @else {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-bottom: $size solid $color;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
